import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EFollowupConditionComparison;
(function (EFollowupConditionComparison) {
  EFollowupConditionComparison["Eq"] = "eq";
  EFollowupConditionComparison["Gt"] = "gt";
  EFollowupConditionComparison["Gte"] = "gte";
  EFollowupConditionComparison["Lt"] = "lt";
  EFollowupConditionComparison["Lte"] = "lte";
  EFollowupConditionComparison["Ne"] = "ne";
  EFollowupConditionComparison["RegEx"] = "regex";
  EFollowupConditionComparison["IsDirty"] = "is-dirty";
  EFollowupConditionComparison["Js"] = "js";
})(EFollowupConditionComparison || (EFollowupConditionComparison = {}));
export const fieldsFollowupWorkflow = _extends({}, fieldsIBaseModel, {
  description: {
    type: 'Text'
  },
  enabled: {
    type: 'Boolean'
  },
  followups: {
    type: 'Object'
  },
  forkedFrom: {
    type: 'ID',
    ref: EModel.FollowupWorkflowGallery
  },
  forkedVersionHash: {
    type: 'Text'
  },
  name: {
    type: 'Text'
  },
  onFailure: {
    type: 'ID',
    ref: EModel.Followup
  },
  publishedTo: {
    type: 'ID',
    ref: EModel.FollowupWorkflowGallery
  }
});